import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const faqs = [
  {
    question: "Ko može da se pridruži Go2 Legende programu?",
    answer: "Svako ko rezerviše putovanje sa Go2 automatski postaje član. Nema posebne registracije niti članarine."
  },
  {
    question: "Kako sakupljam bodove?",
    answer: "Bodove sakupljaš za svaki evro potrošen na kvalifikovana putovanja. Osnovna stopa je 1 bod za 1 EUR, ali viši nivoi donose do 1.4 boda po evru."
  },
  {
    question: "Kako koristim svoje bodove?",
    answer: "Bodove možeš iskoristiti tokom rezervacije za popust. 100 bodova vredi 5 EUR popusta."
  },
  {
    question: "Koji su nivoi i kako ih dostižem?",
    answer: "Postoje tri nivoa: Putnik (početni), Svetski Putnik (800-1499 EUR potrošnje u 24m) i Legenda (1500+ EUR potrošnje u 24m)."
  },
  {
    question: "Koliko dugo važe bodovi?",
    answer: "Bodovi važe 24 meseca od datuma sticanja. Obavestićemo te pre nego što isteknu."
  },
  {
    question: "Mogu li preneti bodove nekom drugom?",
    answer: "Trenutno, bodovi nisu prenosivi i mogu se koristiti samo za rezervacije gde si ti glavni putnik."
  }
];

export const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 uppercase tracking-wide mb-4">
            Često postavljana <span className="text-go2-pink">Pitanja</span>
          </h2>
          <div className="w-24 h-1 bg-go2-yellow mx-auto mb-6"></div>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`rounded-xl border transition-all duration-200 ${
                openIndex === index 
                  ? 'bg-white border-go2-pink shadow-md' 
                  : 'bg-gray-50 border-transparent hover:bg-white hover:border-gray-200'
              }`}
            >
              <button
                className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <span className={`font-bold text-lg ${openIndex === index ? 'text-go2-pink' : 'text-gray-700'}`}>
                  {faq.question}
                </span>
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5 text-go2-pink" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-400" />
                )}
              </button>
              {openIndex === index && (
                <div className="px-6 pb-6 text-gray-600 leading-relaxed border-t border-gray-100 pt-4">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
